import { Copy, KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCopyToClipboard } from "@/hooks/useCopyToClipboard";

// Revela UMA vez o segredo efêmero (chave de API de device.create/rotateKey) no
// card do dock. A chave só existe na resposta viva do confirm (nunca persistida) ⇒ some no F5.
// Mesma UX/aviso do RevealedDeviceKeyCard da tela de CLPs.
export function SecretReveal({ secret }: { secret: string }) {
  const copy = useCopyToClipboard();
  return (
    <div className="border-[var(--rd-warning-500)]/30 mt-2 rounded-md border bg-[var(--rd-warning-50)] p-2.5">
      <div className="flex items-center gap-1.5 text-xs font-medium text-warning-foreground">
        <KeyRound className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
        <span>Guarde a chave agora — não será exibida novamente.</span>
      </div>
      <div className="mt-2 flex items-center gap-2 rounded-md border bg-card px-2 py-1.5 font-mono text-xs">
        <span className="break-all">{secret}</span>
        <Button
          variant="outline"
          size="sm"
          className="ml-auto h-7 shrink-0 gap-1"
          onClick={() => copy(secret, "Chave copiada para área de transferência.")}
          aria-label="Copiar chave"
        >
          <Copy className="h-3 w-3" />
          Copiar
        </Button>
      </div>
    </div>
  );
}
